"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingInfoForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _consts = require("../../../consts");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// Styles
var customPersonalInfoInputStyle = "flex-1 border border-neutral-400 rounded-md px-4 py-[13.5px] shadow text-black text-base placeholder:font-medium placeholder:text-[#757575]";
var customMuiBorderStyle = {
  borderWidth: "1px",
  borderColor: "#CACACA"
};
var customSelectSx = {
  padding: "15px",
  boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  borderRadius: "0.375rem",
  "& .MuiSelect-select": {
    padding: 0,
    color: "#757575"
  },
  "& .MuiOutlinedInput-notchedOutline": customMuiBorderStyle,
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": customMuiBorderStyle,
  "&:hover .MuiOutlinedInput-notchedOutline": customMuiBorderStyle
};
var customInputStyle = "flex-1 border border-neutral-400 rounded-md p-4 shadow";
var CardPlaceholders = function CardPlaceholders(_ref) {
  var onReady = _ref.onReady;
  var containerRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (containerRef.current) {
      // The <div> placeholders are now in the DOM
      onReady === null || onReady === void 0 || onReady(containerRef.current);
    }
  }, [onReady]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: containerRef,
    id: "card-element",
    className: "mt-4 flex flex-col space-y-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "cb-card-number",
    className: customInputStyle
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex w-full gap-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "cb-card-expiry",
    className: customInputStyle
  }), /*#__PURE__*/_react["default"].createElement("div", {
    id: "cb-card-cvv",
    className: customInputStyle
  })));
};
var BillingInfoForm = exports.BillingInfoForm = function BillingInfoForm(_ref2) {
  var email = _ref2.email,
    firstName = _ref2.firstName,
    lastName = _ref2.lastName,
    city = _ref2.city,
    state = _ref2.state,
    zipcode = _ref2.zipcode,
    setEmail = _ref2.setEmail,
    setFirstName = _ref2.setFirstName,
    setLastName = _ref2.setLastName,
    setCity = _ref2.setCity,
    setState = _ref2.setState,
    setZipcode = _ref2.setZipcode,
    setFormError = _ref2.setFormError,
    paymentMethod = _ref2.paymentMethod,
    initializeChargebeeCard = _ref2.initializeChargebeeCard,
    setEmailVerified = _ref2.setEmailVerified,
    _ref2$showEmailInput = _ref2.showEmailInput,
    showEmailInput = _ref2$showEmailInput === void 0 ? false : _ref2$showEmailInput,
    _ref2$formSubmitting = _ref2.formSubmitting,
    formSubmitting = _ref2$formSubmitting === void 0 ? false : _ref2$formSubmitting;
  var handleLetters = function handleLetters(e, callback) {
    var value = e.target.value;
    var regex = /^[A-Za-z\s]*$/;
    if (regex.test(value) || value === "") {
      callback(value);
      setFormError("");
    }
  };
  var handleZipcode = function handleZipcode(e) {
    var value = e.target.value;
    value = value.replace(/\D/g, "");
    if (value.length > 5) value = value.slice(0, 5);
    setZipcode(value);
    setFormError("");
  };
  var isEmailInputEnabled = showEmailInput && typeof setEmail === "function";
  var handleEmail = function handleEmail(e) {
    if (!isEmailInputEnabled) {
      return;
    }
    var emailInput = e.target.value;
    setEmail === null || setEmail === void 0 || setEmail(emailInput.trim());
    setEmailVerified === null || setEmailVerified === void 0 || setEmailVerified(false);
  };

  // no form to enter; should hide entire component
  // not recommend to unmount because then we need to re-initialize the payment component
  var componentHidden = !isEmailInputEnabled && paymentMethod !== "card";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: componentHidden ? "hidden" : "block"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-blue-600 font-bold"
  }, "Billing Info"), /*#__PURE__*/_react["default"].createElement("div", {
    id: "personal-info",
    className: "mt-4 flex flex-col space-y-3"
  }, isEmailInputEnabled && /*#__PURE__*/_react["default"].createElement("input", {
    className: customPersonalInfoInputStyle,
    type: "text",
    placeholder: "Email",
    onChange: handleEmail,
    value: email,
    maxLength: 254,
    disabled: formSubmitting
  }), /*#__PURE__*/_react["default"].createElement(_material.Collapse, {
    "in": paymentMethod === "card",
    timeout: "auto",
    unmountOnExit: false,
    sx: {
      mt: 0
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col space-y-3"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: customPersonalInfoInputStyle,
    type: "text",
    placeholder: "First Name",
    onChange: function onChange(e) {
      return handleLetters(e, setFirstName);
    },
    value: firstName,
    maxLength: 26,
    disabled: formSubmitting
  }), /*#__PURE__*/_react["default"].createElement("input", {
    className: customPersonalInfoInputStyle,
    type: "text",
    placeholder: "Last Name",
    onChange: function onChange(e) {
      return handleLetters(e, setLastName);
    },
    value: lastName,
    maxLength: 26,
    disabled: formSubmitting
  }), /*#__PURE__*/_react["default"].createElement("input", {
    className: customPersonalInfoInputStyle,
    type: "text",
    placeholder: "City",
    onChange: function onChange(e) {
      return handleLetters(e, setCity);
    },
    value: city,
    maxLength: 45,
    disabled: formSubmitting
  }), /*#__PURE__*/_react["default"].createElement(_material.Select, {
    labelId: "chargebee-card-select-country",
    value: "United States",
    onChange: function onChange() {},
    sx: customSelectSx,
    disabled: formSubmitting
  }, /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
    value: "United States"
  }, "United States")), /*#__PURE__*/_react["default"].createElement("input", {
    className: customPersonalInfoInputStyle,
    type: "text",
    placeholder: "ZIP",
    onChange: handleZipcode,
    value: zipcode,
    disabled: formSubmitting
  }), /*#__PURE__*/_react["default"].createElement(_material.Select, {
    sx: customSelectSx,
    value: state,
    onChange: function onChange(e) {
      setState(e.target.value);
      setFormError("");
    },
    disabled: formSubmitting,
    MenuProps: {
      PaperProps: {
        sx: {
          maxHeight: 300,
          overflowY: "auto"
        }
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
    value: "State",
    disabled: true
  }, "State"), _consts.US_STATES.map(function (_ref3) {
    var longState = _ref3.name;
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
      key: longState,
      value: longState
    }, longState);
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-4 text-blue-600 font-bold"
  }, "Card Info"), /*#__PURE__*/_react["default"].createElement(CardPlaceholders, {
    onReady: initializeChargebeeCard
  }))));
};